import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import type { CheckboxRef as AntdCheckboxRef, RadioChangeEvent } from 'antd'
import { Radio, type RadioGroupProps } from '../../Radio'
import type { FormikFieldProps } from '../typings/FieldProps'

export type RadioButtonProps = FormikFieldProps &
  RadioGroupProps & {
    ref?: Ref<AntdCheckboxRef>
  }

export const RadioButton = ({
  name,
  onChange: onChangeProp,
  ...restProps
}: RadioButtonProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      setValue(event.target.value)
      // we don't have "onBlur" event, so we need to mark this input as touched, but in next "tick" to prevent showing error
      setTimeout(() => setTouched(true), 0)
      onChangeProp?.(event)
    },
    [onChangeProp, setTouched, setValue]
  )

  return (
    <Radio.Button
      name={name}
      value={value}
      onChange={handleChange}
      {...restProps}
    />
  )
}
